module.exports = __webpack_public_path__ + "img/disc-s.7e807ad6.png";